import { DecodedRouteParams, NavigateToFn, Route } from 'config/routes';
import React from 'react';

interface SeoLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  children: React.ReactNode;
  routeName: Route;
  routeParams: Partial<DecodedRouteParams>;
  target?: string;
  seoHref: string;
  navigate: NavigateToFn;
}

export const SeoLink: React.FC<SeoLinkProps> = ({
  children,
  routeName,
  routeParams,
  target = '_blank',
  seoHref,
  navigate,
  ...rest
}) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    e.stopPropagation();

    navigate(routeName, routeParams, { openInNewTab: target === '_blank' });
  };

  return (
    <a href={seoHref} target={target} onClick={handleClick} {...rest}>
      {children}
    </a>
  );
};
